import script from "./BaseTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTextArea.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTextArea.vue?vue&type=style&index=0&id=88b20b96&lang=scss"

const __exports__ = script;

export default __exports__